import { useFirebase } from "containers/FirebaseContext";
import {
  collection,
  doc as firestoreDoc,
  getDoc,
  getDocs,
  
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "firebaseConfig";
import { useCurrentUser } from "store/users/selectors";
import * as Sentry from '@sentry/react';

export const useCollectionWidgets = () => {
  const { firestore } = useFirebase();
  const currentUser = useCurrentUser();
  const createCollectionWidgets = async (WidgetsData) => {
    try {
      if(currentUser?.role !== "teacher"){
        return;
      }
  
      // Type validation to prevent TypeError: i.indexOf is not a function
      if (!WidgetsData || typeof WidgetsData !== 'object' || Array.isArray(WidgetsData) || WidgetsData === null) {
        console.warn("createCollectionWidgets: Invalid WidgetsData - expected object, got:", typeof WidgetsData, WidgetsData);
        return;
      }
      
      // Ensure class_id and widget_type are strings
      if (!WidgetsData.class_id || !WidgetsData.widget_type || typeof WidgetsData.class_id !== 'string' || typeof WidgetsData.widget_type !== 'string') {
        console.warn("createCollectionWidgets: Invalid class_id or widget_type - both must be strings");
        return;
      }
   
      const generated_widget_id =
        WidgetsData?.class_id + WidgetsData?.widget_type;
      const docRef = firestoreDoc(
        firestore,
        "share_widgets",
        generated_widget_id
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, WidgetsData);
      } else {
        await setDoc(docRef, WidgetsData);
      }
      return;
    } catch (error) {
      console.log(error, "error");
      Sentry.captureException(`117 Error during Firebase createCollectionWidgets ${error}.`);
    }
  };

  const updateTextCollectionWidgets = async (class_id, text) => {
    try {
      const generated_widget_id =
      class_id + "widget_text";
      const docRef = firestoreDoc(
        firestore,
        "share_widgets",
        generated_widget_id
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const existingData = docSnap.data();
        if(existingData && existingData.status){
          existingData.data.text =text
          await updateDoc(docRef, existingData);
        }
      }
      return;
    } catch (error) {
      console.log(error, "error");
      Sentry.captureException(`118 Error during Firebase updateTextCollectionWidgets ${error}.`);
    }
  };

  const createCollectionTimer = async (WidgetsData) => {
    try {
      const generated_widget_id =
        WidgetsData?.class_id + WidgetsData?.widget_type;
      const docRef = firestoreDoc(
        firestore,
        "widget_timer",
        generated_widget_id
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, WidgetsData);
      } else {
        await setDoc(docRef, WidgetsData);
      }
      return;
    } catch (error) {
      console.log(error, "error");
      Sentry.captureException(`119 Error during Firebase createCollectionTimer ${error}.`);
    }
  };
  
  const updateCollectionWidgets = async (id, userId) => {
    try {
      const notificationsRef = collection(firestore, "share_widgets");
      const q = query(notificationsRef, where("id", "==", id));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach(async (doc) => {
        const data = doc.data();
        const existingUser = data.userSeen && data.userSeen.includes(userId);
        if (!existingUser) {
          const docRef = firestoreDoc(notificationsRef, doc.id);
          await updateDoc(docRef, {
            userSeen: [...(data.userSeen || []), userId],
          });
        }
      });
    } catch (error) {
      Sentry.captureException(`120 Error during Firebase updateCollectionWidgets ${error}.`);
    }
  };

  const uploadOnBucket = (file, location, setPercant) => {
    const storageRef = ref(storage, location);
    try {
      const uploadTask = uploadBytesResumable(storageRef, file);
      return new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const percent = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setPercant(percent);
          },
          (err) => {
            Sentry.captureException(`121 Error during Firebase uploadOnBucket upload ${err}.`);
            reject(err);
          },
          async () => {
            try {
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              if (url) {
                resolve(url);
                setPercant(0);
              }
            } catch (error) {
              console.error(error);
              Sentry.captureException(`122 Error during Firebase uploadOnBucket getDownloadURL ${error}.`);
              reject(error);
            }
          }
        );
      });
    } catch (error) {
      console.error(error);
      Sentry.captureException(`123 Error during Firebase uploadOnBucket ${error}.`);
    }
  };

  const deleteOnBucket = async (location) => {
    const storageRef = ref(storage, location);
    try {
      await deleteObject(storageRef);
    } catch (error) {
      console.error('Error deleting file:', error);
      Sentry.captureException(`124 Error during Firebase deleteOnBucket ${error}.`);
    }
  };
  return { createCollectionWidgets,updateTextCollectionWidgets, updateCollectionWidgets, uploadOnBucket, deleteOnBucket, createCollectionTimer };
};
